import { Nutrition } from 'models/Nutrition'
export const nutritionFormatter = (nutrition: Nutrition) => {
    const base = {
        ...nutrition,
        caloriesPerKilo: `${nutrition.caloriesPerKilo.toFixed()}`,
        crudeFatPercent: `${nutrition.crudeFatPercent.toFixed(1)}%`,
        crudeFiberPercent: `${nutrition.crudeFiberPercent.toFixed(1)}%`, 
        crudeProteinPercent: `${nutrition.crudeProteinPercent.toFixed(1)}%`, 
        moisturePercent: `${nutrition.moisturePercent.toFixed(1)}%`, 
        caloriesPerOunce: `${nutrition.caloriesPerOunce.toFixed()}`,
        caloriesPerCup: undefined,
      }

    if ('caloriesPerCup' in nutrition) {
      return {
        ...base,
        caloriesPerCup: nutrition.caloriesPerCup.toFixed(),
      }
    }

    return base
  }
